<style src="./EventsContent.scss" lang="scss"></style>
<template>
  <ul class="event-container">
    <li
      class="event-info"
      :title="event.participateReason"
      @click="goToEvent">

      <div
        class="option-menu"
        @click.stop="showOptionMenu">
        <icon-right-arrow class="icon" />
      </div>
      
      <div
        class="details"
        :class="{ 'event-info-incomplete': !event.completeInfo }">
        <option-menu
          v-click-outside="hideOptionMenu"
          v-if="optionMenu.visibility"
          :eventId="event.id"
          :event-status="event.eventStatus"
          @close="hideOptionMenu" />
        <div
          :title="event.name"
          class="client"
          :class="{
            'no-participate': event.eventStatus === 2,
            'waiting-no-date': event.eventStatus === 3,
            'waiting-with-date': event.eventStatus === 4,
            'canceled': event.eventStatus === 6,
          }">
          {{ event.name }}
        </div>
        <div class="time-info">
          <span class="eventobject">
            {{ event.eventObject }}
          </span>
          <span class="date">
            {{ event.date && event.date.event | DateTimeBR }}
          </span>
        </div>
        <div class="info">
          <span class="code" title="Código">{{ event.alternativeCode }}</span>
          <span
            :class="{
              'modality-pp': event.modality === 'PP',
              'modality-pe': event.modality === 'PE',
              'modality-est': event.modality === 'EST'
            }"
            class="modality"
            v-show="!!event.modality">
            {{ event.modality }}
          </span>
          <span class="identification" :title="event.identification">
            {{ event.identification }}
          </span>
        </div>
      </div>

    </li>
    <li
      class="task-container"
      v-for="(task, taskIdx) in taskDetails"
      :key="taskIdx"
      @click="taskSelected({ task })">

      <div
        class="task task-normal"
        v-if="!task.exists">
      </div>
      <div
        class="task"
        :class="{
          'task-active': task.status === 'opened',
          'task-inactive': task.status === 'inactive',
          'task-finished': task.status === 'finished',
          'task-wait': task.status === 'wait',
          'task-willstart': task.status === 'willStart'
        }"
        v-if="task.exists">
        <ul
          class="users"
          v-if="task.assignedUser">
          <li
            class="user"
            v-for="(user, userIdx) in reducedUsers(task.assignedUser)"
            :key="userIdx"
            :title="user.name">
            {{ getUserIdentification(user.name) }}
          </li>
        </ul>
        <task-status :status="task.filterStatus" :event="event"/>
        <!-- <task-result :result="event.result" /> -->

        <icon-geometry-star
          class="icon-user-responsible"
          :class="userTaskStatus(task)" />
      </div>
    </li>
  </ul>
</template>

<script>
import { IconUser, IconGeometryStar, IconRightArrow } from '@/components/primitives/icons'
import OptionMenu from '../option-menu/OptionMenu'
import TaskStatus from '../task-status/TaskStatus'
import TaskResult from '../task-result/TaskResult'
import moment from 'moment'

export default {
  name: 'StagesHeader',
  components: {
    IconUser,
    IconGeometryStar,
    IconRightArrow,
    OptionMenu,
    TaskStatus,
    TaskResult
  },
  props: {
    event: {
      default: null
    },
    stages: {
      default: null
    }
  },
  data () {
    return {
      taskDetails: {},
      optionMenu: {
        visibility: false
      }
    }
  },
  filters: {
    DateTimeBR: (dt) => moment(dt).format('DD/MM/YYYY HH:mm')
  },
  watch: {
    event () {
      this.createStageTasks()
    }
  },
  mounted () {
    this.createStageTasks()
  },
  methods: {
    userTaskStatus (task) {
      const meId = this.$store.getters['Login/GET_USER_ID']
      const isAssigned = task.assignedUser.find(user => user && user._id.toString() === meId)
      const isResponsible = task.responsibleUser.find(user => user && user._id.toString() === meId)
      if (isAssigned) { return 'is-assigned' }
      if (isResponsible) { return 'is-responsible' }
      return 'no-interaction'
    },
    createStageTasks () {
      const taskDetails = []
      for (let stage in this.stages) {
        if (!this.event.tasks) {
          taskDetails.push({
            stage: this.stages[stage]._id,
            exists: false
          })
        } else {
          const taskExists = this.event.tasks.findIndex(taskFind => taskFind.stage.toString() === this.stages[stage]._id)
          if (taskExists > -1) {
            taskDetails.push({
              ...this.event.tasks[taskExists],
              stage: this.stages[stage]._id,
              exists: true
            })
          } else {
            taskDetails.push({
              stage: this.stages[stage]._id,
              exists: false
            })
          }
        }
      }
      this.taskDetails = taskDetails
    },
    taskSelected (payload) {
      this.$emit('task-selected', payload)
    },
    goToEvent () {
      const eventDetail = {
        _id: this.event.id,
        identification: this.event.identification,
        alternativeCode: this.event.alternativeCode,
        client: {
          shortName: this.event.name
        },
        date: this.event.date
      }
      const breadcrumb = `[${this.event.alternativeCode}] ${this.event.name} :: ${this.event.identification}`
      const eventId = this.event.id
      this.$store.dispatch('Events/OPEN_EVENT', { eventId, eventDetail, breadcrumb, route: this.$router })
    },
    getUserIdentification (name) {
      if (!name) return '@'
      const splittedName = name.split(' ')
      if (splittedName.length < 2) {
        const userIdentification = name.substr(0, 1) + name.substr(1, 1)
        return userIdentification.toUpperCase()
      } else {
        const userIdentification = splittedName[0].substr(0, 1) + splittedName[1].substr(0, 1)
        return userIdentification.toUpperCase()
      }
    },
    showOptionMenu () {
      this.optionMenu.visibility = true
    },
    hideOptionMenu () {
      this.optionMenu.visibility = false
    },
    reducedUsers (users) {
      let userList = []
      users.map(u => {
        const c1 = userList.some(l => l._id === u._id)
        if (!c1) { userList.push(u) }
      })
      return userList
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/board/components/events-content/EventsContent.vue